/* eslint-disable security/detect-object-injection */

import './ActionField.style.less'

import ActionFieldButton from './components/ActionFieldButton/ActionFieldButton'
import { Row } from 'antd'
import { get } from 'lodash'
import { PlanStatuses } from '../StatusField/StatusField.enum'
import { currentSelectedCollaborator } from '@/jotai/order.jotai'
import { useAuth } from '@/providers/auth.provider'
import { useAtom } from 'jotai'

interface Prop {
  type: string
  current_status: string // ex: Started
  onStatusChanged: (status: PlanStatuses, actualDate: any) => void
  onPercentageChanged: () => void
  data: any
}

export function ActionField(props: Prop) {
  const { current_status, type, onStatusChanged, onPercentageChanged, data } =
    props

  const [currentCollaborator] = useAtom(currentSelectedCollaborator)
  const { user } = useAuth()

  const IsAssignedAndIsUpdater = () => {
    const isUserIsCollaborator = currentCollaborator?.find(
      (collaborator) => collaborator?.user?.id === user?.id
    )
    const currentUserAssigned = props.data.assignments?.find(
      (assignment) => assignment?.user?.id === isUserIsCollaborator?.user.id
    )
    return (
      currentUserAssigned?.user?.id == user?.id &&
      isUserIsCollaborator.roles?.role === 'updater'
    )
  }

  const SubmitComponent = (
    <>
      <ActionFieldButton
        data={data}
        onClicked={(actualDate) => {
          onStatusChanged(PlanStatuses.SUBMITTED, actualDate)
        }}
        className="bg-primary"
        label="Submit"
      />
    </>
  )

  const RejectApproveComponent = IsAssignedAndIsUpdater() ? (
    <div />
  ) : (
    <>
      <ActionFieldButton
        data={data}
        onClicked={(actualDate) => {
          onStatusChanged(PlanStatuses.REJECTED, actualDate)
        }}
        className="button-reject"
        label="Reject"
      />
      <ActionFieldButton
        data={data}
        onClicked={(actualDate) => {
          onStatusChanged(PlanStatuses.APPROVED, actualDate)
        }}
        className="bg-approve"
        label="Approve"
      />
    </>
  )
  const InProgressDoneComponent = (
    <>
      <ActionFieldButton
        data={data}
        onClicked={(actualDate) => {
          onStatusChanged(PlanStatuses.IN_PROGRESS, actualDate)
        }}
        className="bg-primary"
        label="In Progress"
      />
      <ActionFieldButton
        data={data}
        onClicked={(actualDate) => {
          onStatusChanged(PlanStatuses.DONE, actualDate)
        }}
        className="bg-approve"
        label="Done"
      />
    </>
  )

  const DoneComponent = (
    <>
      <ActionFieldButton
        data={data}
        onClicked={(actualDate) => {
          onStatusChanged(PlanStatuses.DONE, actualDate)
        }}
        className="bg-approve"
        label="Done"
      />
    </>
  )

  const PassFailComponent = (
    <>
      <ActionFieldButton
        data={data}
        onClicked={(actualDate) => {
          onStatusChanged(PlanStatuses.FAIL, actualDate)
        }}
        className="button-reject"
        label="Fail"
      />
      <ActionFieldButton
        data={data}
        onClicked={(actualDate) => {
          onStatusChanged(PlanStatuses.PASS, actualDate)
        }}
        className="bg-approve"
        label="Pass"
      />
    </>
  )

  const SaveComponent = (
    <>
      <ActionFieldButton
        data={data}
        onClicked={() => {
          onPercentageChanged()
        }}
        className="bg-approve"
        label="Save"
      />
    </>
  )

  const progress_state = {
    // ['plan_submit_approve_reject_type_Not Planned']: <></>,
    ['plan_submit_approve_reject_type_planned']: SubmitComponent,
    ['plan_submit_approve_reject_type_submitted']: RejectApproveComponent,
    ['plan_submit_approve_reject_type_rejected']: SubmitComponent,
    ['plan_submit_approve_reject_type_approved']: <></>,

    ['plan_start_finish_type_not_planned']: <></>,
    ['plan_inprogress_done_type_planned']: InProgressDoneComponent,
    ['plan_inprogress_done_type_in_progress']: DoneComponent,
    ['plan_start_finish_type_finished']: <></>,

    ['plan_pass_fail_type_not_start']: <></>,
    ['plan_pass_fail_type_planned']: PassFailComponent,
    ['plan_pass_fail_type_pass']: <></>,
    ['plan_pass_fail_type_fail']: <></>,
    ['percentage_progress_type_planned']: SaveComponent,
    ['plan_done_type_Planned Start']: <></>,
  }

  if (current_status === 'new') return <></>

  return (
    <div className="action-field-container">
      <Row wrap={false}>
        {type === 'percentage_progress_type' ? (
          `${type}_${current_status}` === 'percentage_progress_type_100' ? (
            <></>
          ) : (
            SaveComponent
          )
        ) : (
          get(
            progress_state,
            `${type}_${data.value}`,
            get(progress_state, `${type}_${current_status}`, <></>)
          )
        )}
      </Row>
    </div>
  )
}
